// source: environment_booking.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global =
    (typeof globalThis !== 'undefined' && globalThis) ||
    (typeof window !== 'undefined' && window) ||
    (typeof global !== 'undefined' && global) ||
    (typeof self !== 'undefined' && self) ||
    (function () { return this; }).call(null) ||
    Function('return this')();

var google_api_annotations_pb = require('./google/api/annotations_pb.js');
goog.object.extend(proto, google_api_annotations_pb);
goog.exportSymbol('proto.org.codetricks.construction.code.assistant.service.GetEnvironmentBookingRequest', null, global);
goog.exportSymbol('proto.org.codetricks.construction.code.assistant.service.GetEnvironmentBookingResponse', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.org.codetricks.construction.code.assistant.service.GetEnvironmentBookingRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.org.codetricks.construction.code.assistant.service.GetEnvironmentBookingRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.org.codetricks.construction.code.assistant.service.GetEnvironmentBookingRequest.displayName = 'proto.org.codetricks.construction.code.assistant.service.GetEnvironmentBookingRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.org.codetricks.construction.code.assistant.service.GetEnvironmentBookingResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.org.codetricks.construction.code.assistant.service.GetEnvironmentBookingResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.org.codetricks.construction.code.assistant.service.GetEnvironmentBookingResponse.displayName = 'proto.org.codetricks.construction.code.assistant.service.GetEnvironmentBookingResponse';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.org.codetricks.construction.code.assistant.service.GetEnvironmentBookingRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.org.codetricks.construction.code.assistant.service.GetEnvironmentBookingRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.org.codetricks.construction.code.assistant.service.GetEnvironmentBookingRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.codetricks.construction.code.assistant.service.GetEnvironmentBookingRequest.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.org.codetricks.construction.code.assistant.service.GetEnvironmentBookingRequest}
 */
proto.org.codetricks.construction.code.assistant.service.GetEnvironmentBookingRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.org.codetricks.construction.code.assistant.service.GetEnvironmentBookingRequest;
  return proto.org.codetricks.construction.code.assistant.service.GetEnvironmentBookingRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.org.codetricks.construction.code.assistant.service.GetEnvironmentBookingRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.org.codetricks.construction.code.assistant.service.GetEnvironmentBookingRequest}
 */
proto.org.codetricks.construction.code.assistant.service.GetEnvironmentBookingRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.org.codetricks.construction.code.assistant.service.GetEnvironmentBookingRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.org.codetricks.construction.code.assistant.service.GetEnvironmentBookingRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.org.codetricks.construction.code.assistant.service.GetEnvironmentBookingRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.codetricks.construction.code.assistant.service.GetEnvironmentBookingRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.org.codetricks.construction.code.assistant.service.GetEnvironmentBookingResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.org.codetricks.construction.code.assistant.service.GetEnvironmentBookingResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.org.codetricks.construction.code.assistant.service.GetEnvironmentBookingResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.codetricks.construction.code.assistant.service.GetEnvironmentBookingResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
environment: jspb.Message.getFieldWithDefault(msg, 1, ""),
state: jspb.Message.getFieldWithDefault(msg, 2, ""),
observedAt: jspb.Message.getFieldWithDefault(msg, 3, ""),
generation: jspb.Message.getFieldWithDefault(msg, 4, ""),
leaseId: jspb.Message.getFieldWithDefault(msg, 5, ""),
acquiredAt: jspb.Message.getFieldWithDefault(msg, 6, ""),
renewedAt: jspb.Message.getFieldWithDefault(msg, 7, ""),
expiresAt: jspb.Message.getFieldWithDefault(msg, 8, ""),
repository: jspb.Message.getFieldWithDefault(msg, 9, ""),
issue: jspb.Message.getFieldWithDefault(msg, 10, ""),
profile: jspb.Message.getFieldWithDefault(msg, 11, ""),
attempt: jspb.Message.getFieldWithDefault(msg, 12, ""),
candidateSha: jspb.Message.getFieldWithDefault(msg, 13, ""),
phase: jspb.Message.getFieldWithDefault(msg, 14, ""),
standInBy: jspb.Message.getFieldWithDefault(msg, 15, ""),
ownershipKnown: jspb.Message.getBooleanFieldWithDefault(msg, 16, false),
waitersPresent: jspb.Message.getBooleanFieldWithDefault(msg, 17, false),
detail: jspb.Message.getFieldWithDefault(msg, 18, ""),
issueTitle: jspb.Message.getFieldWithDefault(msg, 19, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.org.codetricks.construction.code.assistant.service.GetEnvironmentBookingResponse}
 */
proto.org.codetricks.construction.code.assistant.service.GetEnvironmentBookingResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.org.codetricks.construction.code.assistant.service.GetEnvironmentBookingResponse;
  return proto.org.codetricks.construction.code.assistant.service.GetEnvironmentBookingResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.org.codetricks.construction.code.assistant.service.GetEnvironmentBookingResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.org.codetricks.construction.code.assistant.service.GetEnvironmentBookingResponse}
 */
proto.org.codetricks.construction.code.assistant.service.GetEnvironmentBookingResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setEnvironment(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setState(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setObservedAt(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setGeneration(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setLeaseId(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setAcquiredAt(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setRenewedAt(value);
      break;
    case 8:
      var value = /** @type {string} */ (reader.readString());
      msg.setExpiresAt(value);
      break;
    case 9:
      var value = /** @type {string} */ (reader.readString());
      msg.setRepository(value);
      break;
    case 10:
      var value = /** @type {string} */ (reader.readString());
      msg.setIssue(value);
      break;
    case 11:
      var value = /** @type {string} */ (reader.readString());
      msg.setProfile(value);
      break;
    case 12:
      var value = /** @type {string} */ (reader.readString());
      msg.setAttempt(value);
      break;
    case 13:
      var value = /** @type {string} */ (reader.readString());
      msg.setCandidateSha(value);
      break;
    case 14:
      var value = /** @type {string} */ (reader.readString());
      msg.setPhase(value);
      break;
    case 15:
      var value = /** @type {string} */ (reader.readString());
      msg.setStandInBy(value);
      break;
    case 16:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setOwnershipKnown(value);
      break;
    case 17:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setWaitersPresent(value);
      break;
    case 18:
      var value = /** @type {string} */ (reader.readString());
      msg.setDetail(value);
      break;
    case 19:
      var value = /** @type {string} */ (reader.readString());
      msg.setIssueTitle(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.org.codetricks.construction.code.assistant.service.GetEnvironmentBookingResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.org.codetricks.construction.code.assistant.service.GetEnvironmentBookingResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.org.codetricks.construction.code.assistant.service.GetEnvironmentBookingResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.codetricks.construction.code.assistant.service.GetEnvironmentBookingResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getEnvironment();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getState();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getObservedAt();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getGeneration();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getLeaseId();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getAcquiredAt();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getRenewedAt();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
  f = message.getExpiresAt();
  if (f.length > 0) {
    writer.writeString(
      8,
      f
    );
  }
  f = message.getRepository();
  if (f.length > 0) {
    writer.writeString(
      9,
      f
    );
  }
  f = message.getIssue();
  if (f.length > 0) {
    writer.writeString(
      10,
      f
    );
  }
  f = message.getProfile();
  if (f.length > 0) {
    writer.writeString(
      11,
      f
    );
  }
  f = message.getAttempt();
  if (f.length > 0) {
    writer.writeString(
      12,
      f
    );
  }
  f = message.getCandidateSha();
  if (f.length > 0) {
    writer.writeString(
      13,
      f
    );
  }
  f = message.getPhase();
  if (f.length > 0) {
    writer.writeString(
      14,
      f
    );
  }
  f = message.getStandInBy();
  if (f.length > 0) {
    writer.writeString(
      15,
      f
    );
  }
  f = message.getOwnershipKnown();
  if (f) {
    writer.writeBool(
      16,
      f
    );
  }
  f = message.getWaitersPresent();
  if (f) {
    writer.writeBool(
      17,
      f
    );
  }
  f = message.getDetail();
  if (f.length > 0) {
    writer.writeString(
      18,
      f
    );
  }
  f = message.getIssueTitle();
  if (f.length > 0) {
    writer.writeString(
      19,
      f
    );
  }
};


/**
 * optional string environment = 1;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.service.GetEnvironmentBookingResponse.prototype.getEnvironment = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.service.GetEnvironmentBookingResponse} returns this
 */
proto.org.codetricks.construction.code.assistant.service.GetEnvironmentBookingResponse.prototype.setEnvironment = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string state = 2;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.service.GetEnvironmentBookingResponse.prototype.getState = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.service.GetEnvironmentBookingResponse} returns this
 */
proto.org.codetricks.construction.code.assistant.service.GetEnvironmentBookingResponse.prototype.setState = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string observed_at = 3;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.service.GetEnvironmentBookingResponse.prototype.getObservedAt = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.service.GetEnvironmentBookingResponse} returns this
 */
proto.org.codetricks.construction.code.assistant.service.GetEnvironmentBookingResponse.prototype.setObservedAt = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string generation = 4;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.service.GetEnvironmentBookingResponse.prototype.getGeneration = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.service.GetEnvironmentBookingResponse} returns this
 */
proto.org.codetricks.construction.code.assistant.service.GetEnvironmentBookingResponse.prototype.setGeneration = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string lease_id = 5;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.service.GetEnvironmentBookingResponse.prototype.getLeaseId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.service.GetEnvironmentBookingResponse} returns this
 */
proto.org.codetricks.construction.code.assistant.service.GetEnvironmentBookingResponse.prototype.setLeaseId = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional string acquired_at = 6;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.service.GetEnvironmentBookingResponse.prototype.getAcquiredAt = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.service.GetEnvironmentBookingResponse} returns this
 */
proto.org.codetricks.construction.code.assistant.service.GetEnvironmentBookingResponse.prototype.setAcquiredAt = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional string renewed_at = 7;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.service.GetEnvironmentBookingResponse.prototype.getRenewedAt = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.service.GetEnvironmentBookingResponse} returns this
 */
proto.org.codetricks.construction.code.assistant.service.GetEnvironmentBookingResponse.prototype.setRenewedAt = function(value) {
  return jspb.Message.setProto3StringField(this, 7, value);
};


/**
 * optional string expires_at = 8;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.service.GetEnvironmentBookingResponse.prototype.getExpiresAt = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 8, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.service.GetEnvironmentBookingResponse} returns this
 */
proto.org.codetricks.construction.code.assistant.service.GetEnvironmentBookingResponse.prototype.setExpiresAt = function(value) {
  return jspb.Message.setProto3StringField(this, 8, value);
};


/**
 * optional string repository = 9;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.service.GetEnvironmentBookingResponse.prototype.getRepository = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 9, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.service.GetEnvironmentBookingResponse} returns this
 */
proto.org.codetricks.construction.code.assistant.service.GetEnvironmentBookingResponse.prototype.setRepository = function(value) {
  return jspb.Message.setProto3StringField(this, 9, value);
};


/**
 * optional string issue = 10;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.service.GetEnvironmentBookingResponse.prototype.getIssue = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 10, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.service.GetEnvironmentBookingResponse} returns this
 */
proto.org.codetricks.construction.code.assistant.service.GetEnvironmentBookingResponse.prototype.setIssue = function(value) {
  return jspb.Message.setProto3StringField(this, 10, value);
};


/**
 * optional string profile = 11;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.service.GetEnvironmentBookingResponse.prototype.getProfile = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 11, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.service.GetEnvironmentBookingResponse} returns this
 */
proto.org.codetricks.construction.code.assistant.service.GetEnvironmentBookingResponse.prototype.setProfile = function(value) {
  return jspb.Message.setProto3StringField(this, 11, value);
};


/**
 * optional string attempt = 12;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.service.GetEnvironmentBookingResponse.prototype.getAttempt = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 12, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.service.GetEnvironmentBookingResponse} returns this
 */
proto.org.codetricks.construction.code.assistant.service.GetEnvironmentBookingResponse.prototype.setAttempt = function(value) {
  return jspb.Message.setProto3StringField(this, 12, value);
};


/**
 * optional string candidate_sha = 13;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.service.GetEnvironmentBookingResponse.prototype.getCandidateSha = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 13, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.service.GetEnvironmentBookingResponse} returns this
 */
proto.org.codetricks.construction.code.assistant.service.GetEnvironmentBookingResponse.prototype.setCandidateSha = function(value) {
  return jspb.Message.setProto3StringField(this, 13, value);
};


/**
 * optional string phase = 14;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.service.GetEnvironmentBookingResponse.prototype.getPhase = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 14, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.service.GetEnvironmentBookingResponse} returns this
 */
proto.org.codetricks.construction.code.assistant.service.GetEnvironmentBookingResponse.prototype.setPhase = function(value) {
  return jspb.Message.setProto3StringField(this, 14, value);
};


/**
 * optional string stand_in_by = 15;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.service.GetEnvironmentBookingResponse.prototype.getStandInBy = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 15, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.service.GetEnvironmentBookingResponse} returns this
 */
proto.org.codetricks.construction.code.assistant.service.GetEnvironmentBookingResponse.prototype.setStandInBy = function(value) {
  return jspb.Message.setProto3StringField(this, 15, value);
};


/**
 * optional bool ownership_known = 16;
 * @return {boolean}
 */
proto.org.codetricks.construction.code.assistant.service.GetEnvironmentBookingResponse.prototype.getOwnershipKnown = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 16, false));
};


/**
 * @param {boolean} value
 * @return {!proto.org.codetricks.construction.code.assistant.service.GetEnvironmentBookingResponse} returns this
 */
proto.org.codetricks.construction.code.assistant.service.GetEnvironmentBookingResponse.prototype.setOwnershipKnown = function(value) {
  return jspb.Message.setProto3BooleanField(this, 16, value);
};


/**
 * optional bool waiters_present = 17;
 * @return {boolean}
 */
proto.org.codetricks.construction.code.assistant.service.GetEnvironmentBookingResponse.prototype.getWaitersPresent = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 17, false));
};


/**
 * @param {boolean} value
 * @return {!proto.org.codetricks.construction.code.assistant.service.GetEnvironmentBookingResponse} returns this
 */
proto.org.codetricks.construction.code.assistant.service.GetEnvironmentBookingResponse.prototype.setWaitersPresent = function(value) {
  return jspb.Message.setProto3BooleanField(this, 17, value);
};


/**
 * optional string detail = 18;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.service.GetEnvironmentBookingResponse.prototype.getDetail = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 18, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.service.GetEnvironmentBookingResponse} returns this
 */
proto.org.codetricks.construction.code.assistant.service.GetEnvironmentBookingResponse.prototype.setDetail = function(value) {
  return jspb.Message.setProto3StringField(this, 18, value);
};


/**
 * optional string issue_title = 19;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.service.GetEnvironmentBookingResponse.prototype.getIssueTitle = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 19, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.service.GetEnvironmentBookingResponse} returns this
 */
proto.org.codetricks.construction.code.assistant.service.GetEnvironmentBookingResponse.prototype.setIssueTitle = function(value) {
  return jspb.Message.setProto3StringField(this, 19, value);
};


goog.object.extend(exports, proto.org.codetricks.construction.code.assistant.service);
